// THE RULE FOR A PAID FEATURE, on the screens (decision 9, Carla, round 3, 2026-10-12). The server
// uses the same rule (Aidey Backend/lib/planAccess.js planAllows), so a page the screens show is a
// page whose writes the server accepts:
//   - the plan is at or above the tier, and its subscription has not ENDED;
//   - or the account has NOT chosen a plan yet (plan 'Trial', or none) and is inside its trial;
//   - a trial OF a plan is that plan (a Pro trial is Pro, never Team Pro: decision 6).
// It used to let ANY trial through to EVERY tier, including a household placeholder (plan 'Free').

// Plan hierarchy: higher rank = more features. Mirrors lib/planAccess.js PLAN_RANK.
export const PLAN_RANK = {
  trial: 0, free: 0,
  basic: 1, basics: 1, solo: 1, personal: 1, family: 1, family_extra: 1, // solo: legacy alias for basics (UpgradePage)
  pro: 2, team: 3, enterprise: 4,
};

const ENDED_STATUSES = ['canceled', 'cancelled', 'incomplete_expired', 'unpaid'];

export function planAllows(user, requiredPlan) {
  if (!user) return false;
  const status = String(user.subscriptionStatus || '').trim().toLowerCase();
  if (ENDED_STATUSES.includes(status)) return false;
  const plan = String(user.plan || '').trim().toLowerCase();
  // No plan chosen yet: the open trial reaches everything (the backend-computed isTrialing, or Stripe's).
  if (plan === '' || plan === 'trial') return !!(user.isTrialing || status === 'trialing');
  const userRank = PLAN_RANK[plan] ?? 1;
  const requiredRank = PLAN_RANK[String(requiredPlan || 'pro').trim().toLowerCase()] ?? 2;
  return userRank >= requiredRank;
}

// ── THE MONEY TOOLS, BY FEATURE (UI-24 item 19, Carla, 2026-10-20) ─────────────────────────────────
// Mirrors Aidey Backend/lib/planGates.js FEATURES: Basics gets INVOICES ONLY (10 sent a month);
// purchase orders, expenses, tax summary, transactions and the Xero push are Pro. Tax summary and
// Transactions have no server door of their own (they are computed here from the invoice and expense
// lists); the server refuses the expense, purchase order and Xero writes to Basics.
export const FEATURE_TIER = Object.freeze({
  invoicing: 'basics',
  purchaseOrders: 'pro',
  expenses: 'pro',
  taxSummary: 'pro',
  transactions: 'pro',
  xero: 'pro',
});

// DECISION 4 (Carla, 2026-10-20), STILL OPEN: do Personal and Family include invoicing? Today they do
// NOT, though they rank level with Basics above. To give them invoicing, set this to true HERE and its
// mirror in Aidey Backend/lib/planGates.js (Aidey Backend/tests/invoicingSplit.test.js holds the two
// together).
export const CONSUMER_PLANS_INCLUDE_INVOICING = false;
const CONSUMER_PLANS = ['personal', 'family', 'family_extra'];
const NOT_ON = { invoicing: CONSUMER_PLANS_INCLUDE_INVOICING ? [] : CONSUMER_PLANS };

export function featureAllowed(user, key) {
  const tier = FEATURE_TIER[key];
  if (!tier) throw new Error(`utils/planRule: unknown feature "${key}"`);
  const plan = String((user && user.plan) || '').trim().toLowerCase();
  if ((NOT_ON[key] || []).includes(plan)) return false;
  return planAllows(user, tier);
}
